import { type Static, Type } from "@sinclair/typebox"
import { CursorQuerySchema, createPageSchema, IsoDateTimeSchema, Nullable } from "./common"

// API keys públicas de app (`pk_…`) [V1] — docs/04 §3 y docs/03 §3.
// No son secretos: viajan en el JS del navegador; sirven para atribución,
// binding de orígenes CORS y rate limits por app.

export const AppKeyStatusSchema = Type.Union([Type.Literal("active"), Type.Literal("revoked")])
export type AppKeyStatus = Static<typeof AppKeyStatusSchema>

export const AppKeySchema = Type.Object({
  id: Type.String(),
  name: Type.String(),
  key: Type.String(),
  allowed_origins: Type.Array(Type.String()),
  // Dominio implícito para identificadores sin sufijo enviados con esta key
  default_domain_id: Nullable(Type.String()),
  status: AppKeyStatusSchema,
  last_used_at: Nullable(IsoDateTimeSchema),
  created_by: Nullable(Type.String()),
  created_at: IsoDateTimeSchema,
  updated_at: IsoDateTimeSchema,
})
export type AppKey = Static<typeof AppKeySchema>

export const ListAppKeysQuerySchema = Type.Composite([
  CursorQuerySchema,
  Type.Object({
    q: Type.Optional(Type.String()),
    status: Type.Optional(AppKeyStatusSchema),
  }),
])
export type ListAppKeysQuery = Static<typeof ListAppKeysQuerySchema>

export const AppKeyPageSchema = createPageSchema(AppKeySchema)
export type AppKeyPage = Static<typeof AppKeyPageSchema>

export const CreateAppKeyRequestSchema = Type.Object({
  name: Type.String({ minLength: 1 }),
  allowed_origins: Type.Optional(Type.Array(Type.String())),
  default_domain_id: Type.Optional(Type.String()),
})
export type CreateAppKeyRequest = Static<typeof CreateAppKeyRequestSchema>

export const UpdateAppKeyRequestSchema = Type.Object({
  name: Type.Optional(Type.String({ minLength: 1 })),
  allowed_origins: Type.Optional(Type.Array(Type.String())),
  default_domain_id: Type.Optional(Nullable(Type.String())),
})
export type UpdateAppKeyRequest = Static<typeof UpdateAppKeyRequestSchema>
